import React from 'react';

import { Text } from '@auspost/postmaster-react';

import styles from './InfoRow.module.scss';

interface InfoRowProps {
  heading?: string;
  children?: React.ReactNode;
}
const INFO_ROW_TEST_ID = 'InfoRow';

const InfoRow: React.FC<InfoRowProps> = ({ heading, children }) => (
  <div className={styles.infoRow} data-testid={INFO_ROW_TEST_ID}>
    <Text variant='body-small' weight='medium' className={styles.textLabel}>
      {heading}
    </Text>
    {children}
  </div>
);

export default InfoRow;
export { INFO_ROW_TEST_ID };
